const data = {
  filters: [
    {
      key: 'Work',
      value: false
    },
    {
      key: 'Hobby',
      value: false
    }
  ],
  works: [
    {
      id: 9,
      kind: 'hobby',
      title: 'BrainfuckWebApp',
      shortDetail: 'Vue.jsとNode.jsを使って開発したBrainfuck処理系',
      detail: `ブラウザ上で実行できるBrainfuck処理系です。
処理系自体はNode.js、viewはVue.jsで書いており、全てフロントで完結しています。`,
      repository: 'https://github.com/282Haniwa/BrainfuckWebApp',
      image: 'assets/WorkImages/BrainfuckWebApp.png',
      url: 'https://brainfuckwebapp.firebaseapp.com/'
    },
    {
      id: 8,
      kind: 'Work',
      title: 'ポートフォリオ',
      shortDetail: 'Vue.jsで書かれたこのポートフォリオ',
      detail: `自身の活動を外在化するために開発したポートフォリオです。<br />
プログラムはVue.jsで書いてFirebaseでホスティングしています。<br />
技術力・学習能力をアピールするために、普段利用していないVue.jsを利用して開発しました。<br />
Vue.js学習期間：約１週間<br />
開発期間：約２週間`,
      repository: 'https://github.com/282Haniwa/portfolio',
      image: 'assets/WorkImages/portfolio.png',
      url: 'https://www.usui.work'
    },
    {
      id: 7,
      kind: 'Hobby',
      title: 'LISPインタプリタ',
      shortDetail: '自作のLISPインタプリタ',
      detail: `プログラミング言語を作る方法を学ぶ上で自作したLISPインタプリタです。<br />
初期のLISPにあるすべての機能は開発できていないですが、LISPとして機能する最低限の機能が実装してあります。<br />
プログラムはflex, bison, C言語で書かれています。<br />
開発期間：約１ヶ月`,
      repository: 'https://github.com/282Haniwa/MyLispInterpreter',
      image: 'assets/WorkImages/LispImage.png',
      url: ''
    },
    {
      id: 6,
      kind: 'Hobby',
      title: 'OpenITerm2Here',
      shortDetail: 'iTerm2をFinderから開けるようにするツール',
      detail: `Finderで開いているディレクトリ等をITerm2で開けるようにするアプリケーションです。<br />
同じ機能をもつターミナル版も開発しています。<br />
プログラムはAppleScriptで書かれています。`,
      repository: 'https://github.com/282Haniwa/OpenITerm2Here',
      image: 'assets/WorkImages/OpenITerm2Here.png',
      url: 'https://github.com/282Haniwa/OpenITerm2Here/releases/tag/v1.0'
    },
    {
      id: 5,
      kind: 'Hobby',
      title: 'OpenTerminalHere3',
      shortDetail: 'ターミナルをFinderから開けるようにするツール',
      detail: `Finderで開いているディレクトリ等をターミナルで開けるようにするアプリケーションです。<br />
同じ機能をもつITerm2版も開発しています。<br />
プログラムはAppleScriptで書かれています。`,
      repository: 'https://github.com/282Haniwa/OpenTerminalHere3',
      image: 'assets/WorkImages/OpenTerminalHere3.png',
      url: 'https://github.com/282Haniwa/OpenTerminalHere3/releases/tag/v1.1'
    },
    {
      id: 4,
      kind: 'Hobby',
      title: 'Block Climber',
      shortDetail: '友人と合宿で作成したゲーム',
      detail: `友人と合宿で開発したゲームです。<br />
現在ランキングが機能していないようです。<br />
開発期間：５日`,
      repository: '',
      image: 'assets/WorkImages/BlockClimber.png',
      url: 'https://unityroom.com/games/block-climber'
    },
    {
      id: 3,
      kind: 'Hobby',
      title: 'Unityちゃんの石拾い',
      shortDetail: '初めてUnity1Weekのイベントに参加した時に作成したゲーム',
      detail: `初めてUnity1WeekGameJamのイベントに参加した時に作成したゲームです。<br />
現在ランキングが機能していないようです。<br />
開発期間：１週間`,
      repository: '',
      image: 'assets/WorkImages/UnityChanNoIshiHiroi.png',
      url: 'https://unityroom.com/games/unitychan-no-ishihiroi'
    },
    {
      id: 2,
      kind: 'Hobby',
      title: 'LINEbot2',
      shortDetail: '写真に含まれた文字をテキストに起こすLINEbot',
      detail: `大学１回の終わりの時期に作成したLINEbotです。<br />
メンテナンスはしていないため、現在は動きません。<br />
Google Cloud Vision APIを使って、画像に含まれた文章をテキストに起こすbotを作成しました。`,
      repository: 'https://github.com/282Haniwa/LINEbot2',
      image: 'assets/WorkImages/LINEbot2.png',
      url: ''
    },
    {
      id: 1,
      kind: 'Hobby',
      title: 'LINEbot1',
      shortDetail: '写真からの年齢の判定と日本語と英語の翻訳を行うLINEbot',
      detail: `大学１回の終わりの時期に作成したLINEbotです。<br />
メンテナンスはしていないため、現在は動きません。<br />
Microsoft Computer Vision API, Microsoft Translator APIを使って、顔認識と翻訳ができるbotを作成しました。`,
      repository: 'https://github.com/282Haniwa/LINEbot1',
      image: 'assets/WorkImages/LINEbot1.png',
      url: ''
    }
  ]
}

export default data
